import { render, staticRenderFns } from "./ThetaConfigPage.vue?vue&type=template&id=41953dc1&"
import script from "./ThetaConfigPage.vue?vue&type=script&lang=ts&"
export * from "./ThetaConfigPage.vue?vue&type=script&lang=ts&"
import style0 from "./ThetaConfigPage.vue?vue&type=style&index=0&id=41953dc1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports